import combine from '@eversports/core-io/combine'
import * as s from '@eversports/core-io/sanitizer'
import { Sanitizer, Validator } from '@eversports/core-io/types'
import * as v from '@eversports/core-io/validator'
import { assertNever } from '@eversports/utility-types'

import { AddOn, SelectAddOnFieldSelectionType } from './../../../typings/AdditionalInformation'

/**
 * Generate needed validators for Add-Ons
 */
function getValidation(addOns: Array<AddOn>): ReturnType<typeof combine> {
  const sanitizer: Sanitizer<string | number | Array<string>> = {}
  const validator: Validator<string | Array<string>> = {}

  for (const addOn of addOns) {
    for (const field of addOn.fields!) {
      if (!addOn.mandatory) continue

      switch (field.__typename) {
        case 'TextAddOnField':
          sanitizer[field.id] = s.string({ trim: true })
          validator[field.id] = v.required()
          break
        case 'NumberAddOnField':
          sanitizer[field.id] = s.number()
          validator[field.id] = v.required()
          break
        case 'SelectAddOnField':
          sanitizer[field.id] = [s.string()]
          validator[field.id] = v.array({ min: 1 })
          if (field.selectionType === SelectAddOnFieldSelectionType.SELECTION_TYPE_SINGLE) {
            sanitizer[field.id] = s.string()
            validator[field.id] = v.required()
          }
          break
        default:
          assertNever(field)
      }
    }
  }

  // @ts-ignore Type instantiation is excessively deep and possibly infinite.
  return combine({
    sanitizer: s.sanitizer(sanitizer),
    validator: v.validator(validator),
  })
}

export default getValidation
